<template>
    <iv-modal
        :title="title"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
    >
      <iv-form :model="sources.deliveryData" inline>
        <iv-form-item prop="year" label="榜单项目年：" style="display:block">
          <iv-select v-model="sources.deliveryData.year" style="width:150px">
            <iv-option v-for="item in options.years" :key="item.name" :value="item.id">{{item.name}}</iv-option>
          </iv-select>
        </iv-form-item>
        <iv-row type="flex" justify="start">
          <iv-col>
            <iv-form-item prop="fromIndustryId" label="子行业：" style="width:180px">
              <iv-select v-model="sources.deliveryData.fromIndustryId" style="width:120px">
                <iv-option v-for="item in options.fromIndustry" :key="item.name" :value="item.id">{{item.name}}</iv-option>
              </iv-select>
            </iv-form-item>
          </iv-col>
          <iv-col style="padding: .625em 1em 0;">
            <iv-icon type="md-arrow-round-forward" />
          </iv-col>
          <iv-col>
            <iv-form-item prop="toIndustryId" label="主榜单行业：" style="width:220px">
              <iv-select v-model="sources.deliveryData.toIndustryId" style="width:120px">
                <iv-option v-for="item in options.toIndustry" :key="item.name" :value="item.id">{{item.name}}</iv-option>
              </iv-select>
            </iv-form-item>
          </iv-col>
        </iv-row>
        <iv-form-item prop="deliveryTypeList" label="传递数据类型：" style="display:block">
          <iv-checkbox-group v-model="sources.deliveryData.deliveryTypeList">
            <iv-checkbox v-for="item in options.deliveryType" :key="item.name" :label="item.id">{{item.name}}</iv-checkbox>
          </iv-checkbox-group>
        </iv-form-item>
        <iv-alert type="info">
            <p>1.系统提供子行业数据同步到主榜单行业功能，只会传递指标报告指不传递得分；</p>
            <p>2.“负面行为”传递需要谨慎处理，建议每年只能传递一次，否则容易造成“负面行为”重复</p>
        </iv-alert>
      </iv-form>
      <iv-button type="text" size="large" slot="footer" @click="onCancel">取消</iv-button>
      <iv-button :loading="loader[TARGET_DATA]" type="primary" size="large" slot="footer" @click="onSuccess()">执行</iv-button>
    </iv-modal>
</template>
<script>
import { BusinessError, RequestError, getProductYear, years} from '@/utils/';
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import TargetDataModel from "@/models/TargetDataModel";
import IndustryModel from "@/models/IndustryModel";

const TARGET_DATA = TargetDataModel.ModelName;
const INDUSTRY = IndustryModel.ModelName;
const FORM_NAME = `${TARGET_DATA}Form`;

export default {
    mixins: [
        LoaderMixin(TARGET_DATA),
        ModelMixin({
            contact,
            models: [TargetDataModel,IndustryModel],
        }),
    ],
    props: {
        width: {
            type: [String, Number],
            default: "500",
        },
        value: {
            type: Object,
            default: null,
        },
        title: {
          type:String,
          default: "行业数据传递"
        },
        shown: Boolean,
    },
    watch: {
        shown(val) {
            this.sources.shown = val;
        },
    },
    data() {
        return {
            FORM_NAME,
            TARGET_DATA,
            INDUSTRY,
            options: {
              years: years(),
              fromIndustry: [],
              toIndustry: [],
              deliveryType: [
                {id:0, name:"年报"},
                {id:1, name:"社报"},
                {id:2, name:"负面行为"},
              ]
            },
            sources: {
                //双向绑定字段
                shown: false,
                reportData: null,
                deliveryData: {
                  year: getProductYear(),
                  fromIndustryId: "",
                  toIndustryId: "",
                  deliveryTypeList: [],
                }
            },
        };
    },
    async mounted(){
      this.options.fromIndustry = await this.refreshIndustry({ mainIndustryTag:0 })
      this.options.toIndustry = await this.refreshIndustry({ mainIndustryTag:1 })
    },
    methods: {
        async refreshIndustry(params = {}) {
          const industry = await this.$$fetch(INDUSTRY, params);
          if (!industry) return []
          return industry.data.map(item => ({ ...item, name: item.industry }));
        },
        onCancel() {
            // this.sources.result = this.value;
            this.hide();
        },
        async onSuccess(data=this.sources.deliveryData){
            // const validate = await this.$refs[FORM_NAME].validate();
            // if (!validate) {
            //     this.$$warning('表单验证不通过，请继续填写。');
            //     return Promise.reject(new Error('表单验证不通过，请继续填写。'));
            // }
            this.$$loading(TARGET_DATA)
            const result = await this.$$active(TARGET_DATA, 'delivery', { ...data })

            if([BusinessError, RequestError, Error].indexOf(result.constructor) == -1){
                this.$$loaded(TARGET_DATA)
                //保存至本地并切换下一个指标

                this.$$success(result.msg)
                this.hide();
            }else{
              this.$$error(result)
            }

            this.$$loaded(TARGET_DATA)
        },
        hide() {
            this.sources.deliveryData = {
              year: getProductYear(),
              fromIndustryId: "",
              toIndustryId: "",
              deliveryTypeList: [],
            }
            this.sources.shown = false;
            this.$emit("shown-changed", this.sources.shown);
        },
    },
    computed: {
        repeatDataUnit() {
            return (this.sources.reportData && this.sources.reportData.targetUnit)
                ? this.sources.reportData.targetUnit
                : "--";
        },
    },
};
</script>
<style scoped>
.ivu-tag {
    margin: 5px;
}
.panelList {
    list-style: none;
    padding: 18px 15px;
    font-size: 14px;
    line-height: 28px;
}
.radio-button {
    font-size: 15px;
    border-radius: 5px !important;
}
.addInput {
    margin: 5px;
    display: inline-block;
}
</style>
